import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

/*
 * Hacky-but-explicit: each string here is a `detail` value the accept-plan
 * backend returns when the rate/plan itself is no longer valid (gone,
 * expired, deadline passed, deactivated, or in an unusable state). See
 * backend/apps/api/accept_plans.py and account_enroll.py. Any other failure
 * (auth, validation, server error, etc.) falls through to the generic
 * message. Keep this list in sync with the backend if those strings change.
 */
const RATE_GONE_DETAILS = new Set([
  "not found",
  "expired",
  "start date is after latest allowed start date",
  "start date falls on a weekend/holiday and the next business day is after the latest allowed start date",
  "Plan has been deactivated",
  "Plan is not yet active",
  "Invalid plan state",
]);

/** True when a failed acceptance means the rate itself is no longer usable. */
export function isRateGoneError(
  error: FetchBaseQueryError | undefined,
): boolean {
  const detail =
    error && typeof error.data === "object" && error.data !== null
      ? (error.data as { detail?: unknown }).detail
      : undefined;
  return typeof detail === "string" && RATE_GONE_DETAILS.has(detail);
}

export function getAcceptPlanErrorMessage(
  error: FetchBaseQueryError | undefined,
): string {
  if (isRateGoneError(error)) {
    return "Your original rate has expired. Please review and accept the new rate.";
  }
  return "Something went wrong. Please try enrolling again.";
}
